// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { disabledColor, successColor, unit, white } from '@zego/theme';

import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';

import IconCar from '@zego/static/images/products/motor/car.svg';
import IconPrivateHire from '@zego/static/images/products/motor/private-hire.svg';
import IconScooter from '@zego/static/images/products/motor/scooter.svg';
import IconVan from '@zego/static/images/products/motor/van.svg';

const CustomRadio = styled(({ value, className }) => (
  <div
    css={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor: white,
      padding: unit(2),
      borderRadius: unit(1),
      flexDirection: 'row',
      width: '100%',
      border: `1px solid ${disabledColor(4)}`,
      cursor: 'pointer',
      ':hover': {
        backgroundColor: disabledColor(2),
      },
    }}
    className={className}
    id={value}
  >
    <img
      src={mapValueToIcon(value)}
      alt=""
      css={{
        zIndex: 1,
        width: unit(4),
        height: unit(4),
        display: 'block',
      }}
    />
    <Spacer width={unit(1)} />
    <RegularText css={{ paddingLeft: unit(2) }}>{value}</RegularText>
  </div>
))({});

const RadioLabel = styled('label')({
  display: 'flex',
  flexDirection: 'row',
  cursor: 'pointer',
});

const Radio = styled('input')({
  position: 'absolute',
  opacity: 0,
  width: 0,
  padding: 0,
  height: 0,
  [`&:checked + ${CustomRadio}`]: {
    backgroundColor: white,
    borderColor: successColor(5),
    boxShadow: '0px 2px 6px 0px rgba(0,0,0,0.1)',
    '&:hover': {
      backgroundColor: white,
    },
  },
});

const mapValueToIcon = code => {
  switch (code) {
    case 'Scooter':
      return IconScooter;
    case 'Car':
      return IconCar;
    case 'Private Hire':
      return IconPrivateHire;
    case 'Van':
      return IconVan;
    default:
      return null;
  }
};

const VehicleTypeButton = ({ name, checked, value, onChange }) => (
  <RadioLabel>
    <Radio
      checked={checked}
      onChange={onChange}
      value={value}
      type="radio"
      name={name}
    />
    <CustomRadio value={value} />
  </RadioLabel>
);

export default VehicleTypeButton;
